module.exports = __webpack_public_path__ + "img/creative-commons-pd.ac8f11bf.svg";